import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_UTILISATEURS_REQUEST: 'FETCH_UTILISATEURS_REQUEST',
    FETCH_UTILISATEURS_SUCCESS: 'FETCH_UTILISATEURS_SUCCESS',
    FETCH_UTILISATEURS_FAILURE: 'FETCH_UTILISATEURS_FAILURE',

    FETCH_SUGGESTIONS_UTILISATEUR_REQUEST: 'FETCH_SUGGESTIONS_UTILISATEUR_REQUEST',
    FETCH_SUGGESTIONS_UTILISATEUR_SUCCESS: 'FETCH_SUGGESTIONS_UTILISATEUR_SUCCESS',
    FETCH_SUGGESTIONS_UTILISATEUR_FAILURE: 'FETCH_SUGGESTIONS_UTILISATEUR_FAILURE',

    CLEAR_SUGGESTIONS_UTILISATEUR: 'CLEAR_SUGGESTIONS_UTILISATEUR',

    SET_UTILISATEUR_VALUE: 'SET_SUGGESTIONS_UTILISATEUR_VALUE',
    CLEAR_UTILISATEUR_VALUE: 'CLEAR_SUGGESTIONS_UTILISATEUR_VALUE'
};

/**
 * ActionCreator pour la récupération des utilisateurs
 */
const fetchUtilisateursRequest = (namespace) => ({ type: `${namespace}/${Actions.FETCH_UTILISATEURS_REQUEST}` });
const fetchUtilisateursSuccess = (namespace, items) => ({ type: `${namespace}/${Actions.FETCH_UTILISATEURS_SUCCESS}`, items });
const fetchUtilisateursFailure = (namespace, error) => ({ type: `${namespace}/${Actions.FETCH_UTILISATEURS_FAILURE}`, error });

export const fetchUtilisateurs = (namespace, groupeId) => async (dispatch, getState) => {

    //if (!getState().utilisateur.utilisateurs[namespace].isLoading) {
    dispatch(fetchUtilisateursRequest(namespace));

    try {
        let response = await axios.get(`api/groupes/${groupeId}/utilisateurs`);

        dispatch(fetchUtilisateursSuccess(namespace, response.data));
    } catch (error) {
        dispatch(fetchUtilisateursFailure(namespace, error));
    }
    //}
};

/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsUtilisateurRequest = (namespace) => ({ type: `${namespace}/${Actions.FETCH_SUGGESTIONS_UTILISATEUR_REQUEST}` });
const fetchSuggestionsUtilisateurSuccess = (namespace, utilisateurs) => ({ type: `${namespace}/${Actions.FETCH_SUGGESTIONS_UTILISATEUR_SUCCESS}`, utilisateurs });
const fetchSuggestionsUtilisateurFailure = (namespace, error) => ({ type: `${namespace}/${Actions.FETCH_SUGGESTIONS_UTILISATEUR_FAILURE}`, error });

export const fetchSuggestionsUtilisateur = (namespace, searchValue) => async (dispatch) => {
    dispatch(fetchSuggestionsUtilisateurRequest(namespace));

    try {
        let response = await axios.get('api/utilisateurs/suggestion?query=' + searchValue);

        dispatch(fetchSuggestionsUtilisateurSuccess(namespace, response.data));
    } catch (error) {
        dispatch(fetchSuggestionsUtilisateurFailure(namespace, error));
    }
};

export const clearSuggestionsUtilisateur = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_SUGGESTIONS_UTILISATEUR}` });
export const setUtilisateurValue = (namespace, value, selectedId) => ({ type: `${namespace}/${Actions.SET_UTILISATEUR_VALUE}`, value, selectedId });
export const clearUtilisateurValue = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_UTILISATEUR_VALUE}` });